module.exports = __webpack_public_path__ + "img/spacerabbi_logo.343a8b75.png";